import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { UserPreferencesActions } from '@ninety/platform/state/app-entities/users/users-state.actions';
import { HIDE_USER_TUTORIAL_HANDLER, HideUserTutorialHandler } from '@ninety/ui/core';

/**
 * Binds {@link HIDE_USER_TUTORIAL_HANDLER} (consumed by `VidyardComponent` in `@ninety/ui/core`) to a
 * `platform/state` dispatch. The component stays free of any `@ninety/platform/state` dependency so it
 * can live in the buildable public API; this composition-root wiring is the single place that depends
 * on both the token and `platform/state`. (DEV-26530 6a)
 */
export const VIDYARD_PROVIDERS: Provider[] = [
  {
    provide: HIDE_USER_TUTORIAL_HANDLER,
    useFactory:
      (store: Store): HideUserTutorialHandler =>
      tutorialType =>
        store.dispatch(UserPreferencesActions.hideUserTutorial({ userTutorialType: tutorialType })),
    deps: [Store],
  },
];
